// removed by extract-text-webpack-plugin
module.exports = {"fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","innerPreview":"_1ndtpsozSSIbLf-jlengM5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/elements/Toggles/constants/togglesLayouts.css
// module id = 1183
// module chunks = 0